function getTextWidth(text: string, font: string): number {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return text.length * 10;
  context.font = font; // Ej: "16px Arial"
  const metrics = context.measureText(text);
  return metrics.width;
}

export default getTextWidth;
